import { Component } from '@angular/core';
import { ConfirmedOfferComponent } from 'src/app/components/confirmed-offer/confirmed-offer.component';

@Component({
  selector: 'app-confirmation-success',
  imports: [ConfirmedOfferComponent],
  templateUrl: './confirmation-success.component.html',
  styleUrl: './confirmation-success.component.scss',
})
export class ConfirmationSuccessComponent {}
